import Axios from "../config/config";

export const Add_LIVE_TEST = async (body) => {
    try {
        const response = await Axios.post('add-live-test/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_LIVE_TEST = async (body) => {
    try {
        const response = await Axios.post('edit-live-test/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const VIEW_LIVE_TEST = async (body) => {
    try {
        const response = await Axios.post('view-live-test/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_LIVE_TESTS = async (body) => {
    try {
        const response = await Axios.post('list-live-tests/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_LIVE_SUBMISSION = async (body) => {
    try {
        const response = await Axios.post('list-live-submission/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};